<script>
    import { t, dt } from "totalinvoice-frontend-core"
    import { emptyUser } from '../stores/User'

    export let user = emptyUser()

    export let editable = true
</script>

<div class="form">

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('ID')}</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    {user.id}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('First name')}</label>
        </div>
        <div class="field-body">
            <div class="field is-narrow">
                <div class="control">
                    {user.firstName}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('Last name')}</label>
        </div>
        <div class="field-body">
            <div class="field is-narrow">
                <div class="control">
                    {user.lastName}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('E-mail')}</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    {user.email}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('E-mail verified')}</label>
        </div>
        <div class="field-body">
            <div class="field is-narrow">
                <div class="control">
                    {#if editable}
                        <input type="radio" bind:group={user.emailVerified} value={true}> {$t('Yes')}
                        <input type="radio" bind:group={user.emailVerified} value={false}> {$t('No')}
                    {:else}
                        {$t(user.emailVerified ? 'Yes' : 'No')}
                    {/if}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('Created')}</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    {$dt(new Date(user.createdTimestamp), {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                </div>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label">
            <label for class="label">{$t('Enabled')}</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    {#if editable}
                        <input type="radio" bind:group={user.enabled} value={true}> {$t('Yes')}
                        <input type="radio" bind:group={user.enabled} value={false}> {$t('No')}
                    {:else}
                        {$t(user.enabled ? 'Yes' : 'No')}
                    {/if}
                </div>
            </div>
        </div>
    </div>

</div>
